import React from 'react';

export type ShowIfProps = {
    showIf?: boolean | string;
    children: any;
};

export const ShowIf: React.FC<ShowIfProps> = ({ showIf, children }) => {
    return showIf ? <>{children}</> : null;
};
